import { z } from 'zod'

export function parseBoolean(value: unknown): boolean | undefined {
  const pipeValue = z
    .union([z.literal('true'), z.literal('false'), z.boolean()])
    .safeParse(value).data

  if (pipeValue === undefined) {
    return undefined
  }

  return pipeValue === true || pipeValue === 'true'
}
